import { lazy } from 'react';

const StudentOpportunityPreviewModal = lazy(
  () =>
    import(
      'modules/OpportunityManagement/modals/StudentOpportunityPreviewModal'
    ),
);

export default {
  STUDENT_OPPORTUNITY_PREVIEW_MODAL: StudentOpportunityPreviewModal,
};
